(() => {
  "use strict";
  const hero = document.getElementById("variantHero");
  if (!hero || !window.TZ) return;
  const $ = (s, c = hero) => c.querySelector(s);
  const $$ = (s, c = hero) => Array.from(c.querySelectorAll(s));
  const gsap = window.gsap;
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const animated = !!gsap && !reduced;
  const fine = matchMedia("(hover: hover) and (pointer: fine)").matches;
  const VARIANTS = ["rose", "noir"];
  const COPY = {
    rose: {
      eyebrow: "Heatless curl kit \xB7 Rose",
      name: "in Rose Quartz",
      desc: "Blush satin curler, bonnet, claw clip and scrunchies. Wrap tonight, wake up to soft, romantic curls.",
      cta: "Add to bag \xB7 Rose",
      status: "Kit Rose selected"
    },
    noir: {
      eyebrow: "Heatless curl kit \xB7 Noir",
      name: "in Onyx Noir",
      desc: "Jet satin curler, bonnet, claw clip and scrunchies. Wrap tonight, wake up to glossy, polished curls.",
      cta: "Add to bag \xB7 Noir",
      status: "Kit Noir selected"
    }
  };
  const AUTOPLAY_MS = 5e3;
  let current = VARIANTS.includes(TZ.getShade()) ? TZ.getShade() : "rose";
  let busy = false, tl = null, queued = null;
  function loadVariant(v) {
    $$('img[data-v="'.concat(v, '"][data-src], .vh-card--').concat(v, " img[data-src]")).forEach((img) => {
      img.src = img.dataset.src;
      img.removeAttribute("data-src");
    });
  }
  loadVariant(current);
  const preloadOthers = () => VARIANTS.forEach(loadVariant);
  setTimeout(preloadOthers, 600);
  const lines = $$(".vh-l");
  function setCopy(v) {
    const c = COPY[v];
    $$("[data-vh]").forEach((el) => {
      el.textContent = c[el.dataset.vh];
    });
    $("#vhStatus").textContent = c.status;
    const sv = window.TZ_PRODUCT && TZ_PRODUCT.variants && TZ_PRODUCT.variants[v];
    const soldOut = !!sv && !sv.available;
    $("#vhAdd").disabled = soldOut || !sv;
    $('[data-vh="cta"]').textContent = !sv ? "Coming soon" : soldOut ? "Sold out \xB7 ".concat(v === "noir" ? "Noir" : "Rose") : c.cta;
  }
  function setStatic(v) {
    hero.dataset.variant = v;
    $$("[data-v]").forEach((img) => img.classList.toggle("is-current", img.dataset.v === v));
    $$(".vh-card").forEach((c) => c.setAttribute("aria-pressed", c.dataset.variant === v));
    $("#vhCount").textContent = "".concat(VARIANTS.indexOf(v) + 1, " / ").concat(VARIANTS.length);
  }
  setCopy(current);
  setStatic(current);
  const floats = $$(".vh-float");
  if (animated) {
    floats.forEach((f, i) => {
      gsap.to($(".vh-bob", f), {
        y: +f.dataset.bobY,
        rotation: "+=".concat(f.dataset.bobRot),
        duration: +f.dataset.bobDur,
        ease: "sine.inOut",
        yoyo: true,
        repeat: -1,
        delay: i * 0.35
      });
    });
    gsap.to("#vhBandWrap", { y: -10, duration: 3.2, ease: "sine.inOut", yoyo: true, repeat: -1 });
    if (!fine) {
      floats.forEach((f, i) => {
        const d = +f.dataset.depth;
        gsap.to(f, { x: (i % 2 ? -1 : 1) * 12 * d, y: (i < 2 ? -1 : 1) * 9 * d, duration: 4.2 + i * 0.7, ease: "sine.inOut", yoyo: true, repeat: -1, delay: i * 0.4 });
      });
      gsap.to("#vhBandWrap", { x: 4, duration: 5, ease: "sine.inOut", yoyo: true, repeat: -1 });
    }
    if (fine) {
      const movers = floats.map((f) => ({
        depth: +f.dataset.depth,
        x: gsap.quickTo(f, "x", { duration: 0.9, ease: "power3.out" }),
        y: gsap.quickTo(f, "y", { duration: 0.9, ease: "power3.out" })
      }));
      const band = { x: gsap.quickTo("#vhBandWrap", "x", { duration: 1.1, ease: "power3.out" }) };
      hero.addEventListener("mousemove", (e) => {
        const r = hero.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        movers.forEach((m) => {
          m.x(px * 28 * m.depth);
          m.y(py * 24 * m.depth);
        });
        band.x(px * -10);
      });
      hero.addEventListener("mouseleave", () => {
        movers.forEach((m) => {
          m.x(0);
          m.y(0);
        });
        band.x(0);
      });
    }
  }
  function change(next, { fromPage = false } = {}) {
    if (busy) {
      queued = next;
      return;
    }
    if (next === current) return;
    const prev = current;
    current = next;
    if (!fromPage) TZ.applyShade(next);
    loadVariant(next);
    const outBand = $('.vh-band[data-v="'.concat(prev, '"]')), inBand = $('.vh-band[data-v="'.concat(next, '"]'));
    const outFloats = floats.map((f) => $('img[data-v="'.concat(prev, '"]'), f));
    const inFloats = floats.map((f) => $('img[data-v="'.concat(next, '"]'), f));
    if (!animated) {
      const all = [outBand, inBand, ...outFloats, ...inFloats, ...lines];
      all.forEach((el) => {
        el.style.transition = "opacity .45s ease";
      });
      lines.forEach((l) => {
        l.style.opacity = 0;
      });
      setTimeout(() => {
        setStatic(next);
        setCopy(next);
        lines.forEach((l) => {
          l.style.opacity = 1;
        });
      }, 220);
      return;
    }
    busy = true;
    tl = gsap.timeline({
      defaults: { ease: "power3.inOut" },
      onComplete: () => {
        busy = false;
        gsap.set([outBand, ...outFloats], { clearProps: "all" });
        gsap.set([inBand, ...inFloats, ...lines], { clearProps: "opacity,filter,transform" });
        if (queued) {
          const q = queued;
          queued = null;
          change(q);
        }
      }
    });
    tl.to(outBand, { yPercent: 115, filter: "blur(6px)", duration: 0.5, ease: "power2.in" }, 0);
    outFloats.forEach((img, i) => {
      const f = floats[i];
      tl.to(img, { x: f.dataset.dx * 120, y: f.dataset.dy * 90, scale: 0.8, opacity: 0, rotation: f.dataset.dx * 18, duration: 0.42, ease: "power2.in" }, i * 0.04);
    });
    tl.to(lines, { opacity: 0, y: -10, filter: "blur(8px)", duration: 0.3, stagger: 0.04, ease: "power2.in" }, 0);
    tl.add(() => {
      hero.dataset.variant = next;
      $$(".vh-card").forEach((c) => c.setAttribute("aria-pressed", c.dataset.variant === next));
      $("#vhCount").textContent = "".concat(VARIANTS.indexOf(next) + 1, " / ").concat(VARIANTS.length);
      setCopy(next);
    }, 0.12);
    tl.add(() => {
      inBand.classList.add("is-current");
      outBand.classList.remove("is-current");
    }, 0.3);
    tl.fromTo(
      inBand,
      { yPercent: 115, opacity: 1, filter: "blur(4px)" },
      { yPercent: 0, filter: "blur(0px)", duration: 0.62, ease: "elastic.out(1, 0.8)", immediateRender: false },
      0.3
    );
    tl.add(() => {
      inFloats.forEach((i) => i.classList.add("is-current"));
      outFloats.forEach((i) => i.classList.remove("is-current"));
    }, 0.4);
    inFloats.forEach((img, i) => {
      const f = floats[i];
      tl.fromTo(
        img,
        { x: f.dataset.dx * 130, y: f.dataset.dy * 100, scale: 0.85, opacity: 0, rotation: -f.dataset.dx * 14 },
        { x: 0, y: 0, scale: 1, opacity: 1, rotation: 0, duration: 0.5, ease: "power3.out", immediateRender: false },
        0.4 + i * 0.07
      );
    });
    tl.fromTo(
      lines,
      { opacity: 0, y: 14, filter: "blur(10px)" },
      { opacity: 1, y: 0, filter: "blur(0px)", duration: 0.45, stagger: 0.06, ease: "power3.out", immediateRender: false },
      0.36
    );
  }
  const step = (dir) => change(VARIANTS[(VARIANTS.indexOf(queued || current) + dir + VARIANTS.length) % VARIANTS.length]);
  const stopAutoplay = () => {
  };
  const choose = (fn) => (...args) => {
    stopAutoplay();
    fn(...args);
  };
  $$(".vh-card").forEach((c) => c.addEventListener("click", choose(() => change(c.dataset.variant))));
  $("#vhPrev").addEventListener("click", choose(() => step(-1)));
  $("#vhNext").addEventListener("click", choose(() => step(1)));
  hero.addEventListener("keydown", (e) => {
    if (e.target.closest("input, textarea, select")) return;
    if (["ArrowDown", "ArrowRight"].includes(e.key)) {
      e.preventDefault();
      choose(step)(1);
    }
    if (["ArrowUp", "ArrowLeft"].includes(e.key)) {
      e.preventDefault();
      choose(step)(-1);
    }
  });
  $("#vhAdd").addEventListener("click", () => {
    stopAutoplay();
    TZ.addToCart(current, false, 1);
    TZ.openCart();
  });
  const stage = $("#vhStage");
  let sx = 0, sy = 0;
  stage.addEventListener("touchstart", (e) => {
    sx = e.touches[0].clientX;
    sy = e.touches[0].clientY;
  }, { passive: true });
  stage.addEventListener("touchend", (e) => {
    const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) choose(step)(dx < 0 ? 1 : -1);
  }, { passive: true });
  document.addEventListener("tz:shade", (e) => {
    if (e.detail === current) return;
    stopAutoplay();
    if (busy && tl) tl.progress(1);
    change(e.detail, { fromPage: true });
  });
})();
